import { Component, inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ContractsService } from "@app/services/contracts/contracts.service";
import { ValidationService } from "@app/services/validation/validation.service";

@Component({
  selector: "app-contract-no-auth",
  templateUrl: "./contract-no-auth.component.html",
  styleUrls: ["./contract-no-auth.component.scss"],
})
export class ContractNoAuthComponent {
  private _fb: FormBuilder = inject(FormBuilder);
  private _contract: ContractsService = inject(ContractsService);
  private _validations: ValidationService = inject(ValidationService);

  form: FormGroup = this._fb.group({
    signature: [null, [Validators.required]],
    printedName: [null, [Validators.required]],
    npn: [null, [Validators.required]],
    title: [null, [Validators.required]],
  });

  controlHasError = this._validations.controlHasError;

  constructor() {
    this._contract.formContract = this.form;
  }

  get lead() {
    return this._contract.lead;
  }

  get namePlaceholder() {
    if (!this.lead) return "E.g. John Doe";

    return `${this.lead?.FirstName} ${this.lead?.LastName}`;
  }

  controlValue(control: string) {
    return this.form.get(control)?.value;
  }
}
